import { useCallback, useEffect, useState } from "react";
import { getCJWUploadHistory } from "../../API/CJWUploadHistoryApi";
import { getCJWDIUploadHistory } from "../../API/CJWDIUploadHistoryApi";
//import config from "../../../config";

export const useUploadHistory = (isDIMode = false) => {
    const [uploadHistory, setUploadHistory] = useState([]);
    const [page, setPage] = useState(0);
    const [loading, setLoading] = useState(true);

    const fetchUploadHistory = useCallback(async () => {
        try{
            setLoading(true);
            setUploadHistory([]); // Clear old data before fetching new data

            const data = isDIMode ? await getCJWDIUploadHistory() : await getCJWUploadHistory();
            setUploadHistory(data || []);
            // setTotalPages(data.totalPages || config.amountPages);
            // setTotalPages(29);
        } catch (error) {
            console.error("Error fetching upload history:", error);
            setUploadHistory([]); // Clear data on error
        } finally {
            setLoading(false);
        }
        // console.log("page fetchUploadHistory", page)
    }, [isDIMode]);

    useEffect(() => {
        fetchUploadHistory();
    }, [fetchUploadHistory]);

    return {
        fetchUploadHistory,
        uploadHistory,
        page,
        setPage,
        loading,
    };
};
